const maxBreakpoint = 1366
const largeBreakpoint = 1024
const mediumBreakpoint = 768
const smallBreakpoint = 480

const max = 'max'
const large = 'large'
const medium = 'medium'
const small = 'small'

export const breakpoint = {
  [max]: `${maxBreakpoint}px`,
  [large]: `${largeBreakpoint}px`,
  [medium]: `${mediumBreakpoint}px`,
  [small]: `${smallBreakpoint}px`,
}

export const mediaQuery = {
  [max]: `(min-width: ${maxBreakpoint}px)`,
  [large]: `(min-width: ${largeBreakpoint}px) and (max-width: ${maxBreakpoint - 1}px)`,
  [`${large}Up`]: `(min-width: ${largeBreakpoint}px)`,
  [`${large}Down`]: `(max-width: ${maxBreakpoint - 1}px)`,
  [medium]: `(min-width: ${mediumBreakpoint}px) and (max-width: ${largeBreakpoint - 1}px)`,
  [`${medium}Up`]: `(min-width: ${mediumBreakpoint}px)`,
  [`${medium}Down`]: `(max-width: ${largeBreakpoint - 1}px)`,
  [small]: `(max-width: ${smallBreakpoint}px)`,
  [`${small}Up`]: `(min-width: ${smallBreakpoint + 1}px)`,
}
